import './App.css';
import './css/reset.css';
import Homepage from './components/Homepage.jsx';
import Portfolio from './components/Portfolio.jsx';
import About from './components/About.jsx';
import Pricing from './components/Pricing.jsx';
import Contact from './components/Contact.jsx';
import { useState } from 'react';

function App() {
  const [currentComponent, setCurrentComponent] = useState('home');

  function renderPage() {
    switch(currentComponent) {
      case 'home':
        return <Homepage currentComponent={currentComponent} setCurrentComponent={setCurrentComponent} />;

      case 'portfolio':
        return <Portfolio currentComponent={currentComponent} setCurrentComponent={setCurrentComponent} />;

      case 'about':
        return <About currentComponent={currentComponent} setCurrentComponent={setCurrentComponent} />;

      case 'pricing':
        return <Pricing currentComponent={currentComponent} setCurrentComponent={setCurrentComponent} />;

      case 'contact':
        return <Contact currentComponent={currentComponent} setCurrentComponent={setCurrentComponent} />;

      default:
        return <Homepage currentComponent={currentComponent} setCurrentComponent={setCurrentComponent} />;
    }
  }

  return (
    <div className="App">
      {renderPage()}
    </div>
  );
}

export default App;
